export enum EPersistKey {
  PICK_TEMPLATE = '_pick_template',
  GENERAL = '_general',
  ORDER_LISTING = '_order_listing',
  DASHBOARD_DISMISS = '_dashboard_dismiss',
  NOTIFICATION = '_notification',
  EXPANDED_ANALYTICS = '_expanded_analytics',
  ONBOARDING_STATUS = '_onboarding_status',
  SETUP_GUIDE = '_setup_guide',
  SETUP_GUIDE_PRICE_SEEN = '_setup_guide_price_seen',
  SETUP_GUIDE_URL_REDIRECT_SEEN = '_setup_guide_url_redirect_seen',
  UPGRADED_PLAN = '_upgraded_plan',
  PRICING_DISMISS = '_pricing_dismiss',
  VIEW_ALL_STORE_ORDERS = '_view_all_store_orders_',
  ANNOUNCEMENT_BANNER = '_announcement_banner',
}
